import script from "./category-admin.vue?vue&type=script&lang=ts&setup=true"
export * from "./category-admin.vue?vue&type=script&lang=ts&setup=true"

import "./category-admin.vue?vue&type=style&index=0&id=17b80e9a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b80e9a"]])

export default __exports__